export default __webpack_public_path__ + "static/media/eventPlan.674938e2.png";